<template>
  <div
    :class="{ 'visible': isOpen }"
    class="modal-wrapper medium-width big"
  >
    <div class="modal">
      <div class="modal-body">
        <h2 class="is-size-5 has-text-weight-bold">Averaged Scores</h2>
        <table class="table is-fullwidth is-striped">
          <thead>
            <tr>
              <td class="has-text-grey">Rubric</td>
              <td class="has-text-grey">Score</td>
              <td class="has-text-grey">Comments/Observations</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="rubric in finalScores">
              <td class="has-text-grey-dark">{{ rubric.name }}</td>
              <td>{{ rubric.score }}</td>
              <td>
                <div v-if="rubric.comments.length > 0">
                  <p
                    v-for="(comment, index) in rubric.comments"
                    :key="index"
                  ><em>"{{ comment }}"</em></p>
                </div>
                <div v-else>
                  <span class="has-text-grey">-</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <hr>
        <h2 class="is-size-5 has-text-weight-bold">Per Judge</h2>
        <div
          v-for="score in scores"
          :key="score.judge"
          class="mt-15"
        >
          <JudgeNameHelper :id="score.judge" />
          <table class="table is-fullwidth is-striped">
            <thead>
              <tr>
                <td class="has-text-grey">Rubric</td>
                <td class="has-text-grey">Score</td>
                <td class="has-text-grey">Comments/Observations</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="rubric in score.rubrics">
                <td class="has-text-grey-dark">{{ rubric.name }}</td>
                <td>{{ rubric.score }}</td>
                <td>
                  <div v-if="rubric.comment.length > 0">
                    <p<em>"{{ rubric.comment }}"</em></p>
                  </div>
                  <div v-else>
                    <span class="has-text-grey">-</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <span>&nbsp;</span>
        <a
          href="#"
          class="button is-dark"
          @click.prevent="closeModal(false)"
        >Close</a>
      </div>
    </div>
  </div>
</template>

<script>
import JudgeNameHelper from '@/components/modals/JudgeNameHelper'

export default {
  name: 'ScoresModal',
  components: {
    JudgeNameHelper
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    scores: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      rubricsScores: {},
      finalScores: {}
    }
  },
  mounted () {
    this.scores.map(score => {
      score.rubrics.map(rubric => {
        if (rubric.slug in this.rubricsScores) {
          this.rubricsScores[rubric.slug]['scores'].push(rubric.score)
          this.rubricsScores[rubric.slug]['score'] = Math.round(this.rubricsScores[rubric.slug]['scores'].reduce((a, b) => { return a+b}) / this.rubricsScores[rubric.slug]['scores'].length * 100) / 100
        } else {
          this.rubricsScores[rubric.slug] = {
            name: rubric.name,
            score: rubric.score,
            scores: [rubric.score],
            comments: []
          }
        }

        if (rubric.comment.length > 0) {
          this.rubricsScores[rubric.slug]['comments'].push(rubric.comment)
        }
      })
    })
    this.finalScores = this.rubricsScores
  },
  methods: {
    async getUser (id) {
      return await this.$store
        .dispatch('users/GET_USER', id)
        .then(res => {
          return `${res.data.firstName}`
        })
    },
    closeModal () {
      this.$emit('closeModal')
    }
  }
}
</script>
